"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FindFlowInstancesResponse = void 0;
const entity_repository_1 = require("../entity-repository");
class FindFlowInstancesResponse extends entity_repository_1.PaginationResponse {
}
exports.FindFlowInstancesResponse = FindFlowInstancesResponse;
//# sourceMappingURL=api.js.map